<template>
  <div class="pm-pv d-flex flex-column flex-grow-1 min-h-0 overflow-hidden pa-6">
    <div class="d-flex justify-space-between align-center mb-4 flex-shrink-0 gap-4 flex-wrap">
      <v-form class="d-flex align-center ga-4 flex-wrap flex-grow-1" @submit.prevent="handleQuery">
        <div class="search-item">
          <span class="search-label">型号名称</span>
          <v-text-field v-model.trim="queryForm.modelName" maxlength="100" placeholder="请输入" variant="outlined"
            density="compact" hide-details rounded="xl" class="search-input" @keyup.enter="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">厂家名称</span>
          <v-text-field v-model.trim="queryForm.factoryName" maxlength="100" placeholder="请输入" variant="outlined"
            density="compact" hide-details rounded="xl" class="search-input" @keyup.enter="handleQuery" />
        </div>
        <div class="search-item">
          <span class="search-label">产品型号</span>
          <v-text-field v-model.trim="queryForm.productModel" maxlength="100" placeholder="请输入" variant="outlined"
            density="compact" hide-details rounded="xl" class="search-input" @keyup.enter="handleQuery" />
        </div>
        <div class="d-flex align-center ga-3 flex-wrap">
          <v-btn color="#2655f1" variant="flat" rounded="pill" prepend-icon="mdi-magnify" @click="handleQuery">
            查询
          </v-btn>
          <v-btn variant="outlined" color="#2655f1" rounded="pill" prepend-icon="mdi-refresh" @click="handleReset">
            重置
          </v-btn>
        </div>
      </v-form>
      <div class="flex-shrink-0 ml-auto">
        <v-btn color="#2655f1" variant="flat" rounded="pill" size="default" class="pm-toolbar-add px-5"
          prepend-icon="mdi-plus" @click="openAdd">
          新增
        </v-btn>
      </div>
    </div>

    <div class="pv-table-outer" v-loading="listLoading">
      <div class="table-wrap">
        <v-table class="gm-table bg-transparent border-none pm-table-native" density="comfortable" fixed-header
          height="100%">
          <thead>
            <tr>
              <th>型号名称</th>
              <th>厂家名称</th>
              <th>产品型号</th>
              <th>最大直流电压(V)</th>
              <th>最大直流功率(kW)</th>
              <th>额定输出功率(kW)</th>
              <th>最大输出功率(kW)</th>
              <th>最大交流输出电流(A)</th>
              <th>最大输入电流(A)</th>
              <th>额定电网电压(V)</th>
              <th>额定电网频率(Hz)</th>
              <th class="text-center" style="width: 220px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td>{{ row.modelName }}</td>
              <td>{{ row.factoryName }}</td>
              <td>{{ row.productModel }}</td>
              <td>{{ row.maxDcVoltage }}</td>
              <td>{{ row.maxDcPower }}</td>
              <td>{{ row.ratedOutputPower }}</td>
              <td>{{ row.maxOutputPower }}</td>
              <td>{{ row.maxAcOutputCurrent }}</td>
              <td>{{ row.maxInputCurrent }}</td>
              <td>{{ row.ratedGridVoltage }}</td>
              <td>{{ row.ratedGridFrequency }}</td>
              <td class="text-center">
                <v-btn variant="text" color="#2655f1" rounded="xl" @click="openView(row)">查看</v-btn>
                <v-btn variant="text" color="#2655f1" rounded="xl" @click="openEdit(row)">编辑</v-btn>
                <v-btn variant="text" color="#FF6A46" rounded="xl" @click="openDelete(row)">删除</v-btn>
              </td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="12" class="text-center text-medium-emphasis py-8">暂无数据</td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </div>

    <TablePagination v-model="page" v-model:page-size="pageSize" :total="total" :has-sizes="true" :has-jump="true"
      @change="fetchRows" />

    <v-dialog v-model="editOpen" max-width="900" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-5">
          <div class="text-h5"><span style="color: #2655f1">属性</span><span>{{ dialogTitle }}</span></div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="editOpen = false" />
        </div>
        <v-card-text class="px-8 pt-0 pb-4 scrollbar-hide" style="max-height: 82vh; overflow-y: auto">
          <div class="section-title">基础属性</div>
          <table class="pm-prop-table" cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th class="col-name">属性名称</th>
                <th class="col-val">属性值</th>
                <th class="col-unit">属性单位</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>型号名称 <span v-if="!isView" class="required-star">*</span></td>
                <td><v-text-field v-model="form.modelName" :readonly="isView" variant="outlined" density="compact"
                    :hide-details="isView ? true : 'auto'" class="gm-input"
                    :error-messages="isView ? [] : modelNameErrors" /></td>
                <td class="text-center text-medium-emphasis">--</td>
              </tr>
              <tr>
                <td>厂家名称</td>
                <td><v-text-field v-model="form.factoryName" :readonly="isView" variant="outlined" density="compact"
                    hide-details class="gm-input" /></td>
                <td class="text-center text-medium-emphasis">--</td>
              </tr>
              <tr>
                <td>产品型号 <span v-if="!isView" class="required-star">*</span></td>
                <td><v-text-field v-model="form.productModel" :readonly="isView" variant="outlined" density="compact"
                    :hide-details="isView ? true : 'auto'" class="gm-input"
                    :error-messages="isView ? [] : productModelErrors" /></td>
                <td class="text-center text-medium-emphasis">--</td>
              </tr>
              <tr>
                <td>最大直流电压</td>
                <td><v-text-field v-model="form.maxDcVoltage" :readonly="isView" variant="outlined" density="compact"
                    hide-details class="gm-input" /></td>
                <td class="text-center">V</td>
              </tr>
              <tr>
                <td>最大直流功率</td>
                <td><v-text-field v-model="form.maxDcPower" :readonly="isView" variant="outlined" density="compact"
                    hide-details class="gm-input" /></td>
                <td class="text-center">kW</td>
              </tr>
              <tr>
                <td>额定输出功率</td>
                <td><v-text-field v-model="form.ratedOutputPower" :readonly="isView" variant="outlined"
                    density="compact" hide-details class="gm-input" /></td>
                <td class="text-center">kW</td>
              </tr>
              <tr>
                <td>最大输出功率</td>
                <td><v-text-field v-model="form.maxOutputPower" :readonly="isView" variant="outlined" density="compact"
                    hide-details class="gm-input" /></td>
                <td class="text-center">kW</td>
              </tr>
              <tr>
                <td>最大交流输出电流</td>
                <td><v-text-field v-model="form.maxAcOutputCurrent" :readonly="isView" variant="outlined"
                    density="compact" hide-details class="gm-input" /></td>
                <td class="text-center">A</td>
              </tr>
              <tr>
                <td>最大输入电流</td>
                <td><v-text-field v-model="form.maxInputCurrent" :readonly="isView" variant="outlined" density="compact"
                    hide-details class="gm-input" /></td>
                <td class="text-center">A</td>
              </tr>
              <tr>
                <td>额定电网电压</td>
                <td><v-text-field v-model="form.ratedGridVoltage" :readonly="isView" variant="outlined"
                    density="compact" hide-details class="gm-input" /></td>
                <td class="text-center">V</td>
              </tr>
              <tr>
                <td>额定电网频率</td>
                <td><v-text-field v-model="form.ratedGridFrequency" :readonly="isView" variant="outlined"
                    density="compact" hide-details class="gm-input" /></td>
                <td class="text-center">Hz</td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex align-center justify-space-between mt-6 mb-2">
            <div class="section-title mb-0">其他属性</div>
            <v-btn v-if="!isView" variant="text" color="#2655f1" size="small" prepend-icon="mdi-plus"
              @click="addExtendParam">
              新增属性
            </v-btn>
          </div>
          <table class="pm-prop-table" cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th class="col-ext-name">属性名称</th>
                <th class="col-ext-unit">属性单位</th>
                <th class="col-ext-key">key</th>
                <th class="col-ext-type">数据类型</th>
                <th class="col-ext-val">属性值</th>
                <th v-if="!isView" class="col-ext-op text-center">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in form.extendParams" :key="index">
                <td>
                  <v-text-field v-model="item.paramName" :readonly="isView" variant="outlined" density="compact"
                    hide-details maxlength="128" class="gm-input" placeholder="请输入" />
                </td>
                <td>
                  <v-text-field v-model="item.unit" :readonly="isView" variant="outlined" density="compact" hide-details
                    maxlength="32" class="gm-input" placeholder="请输入" />
                </td>
                <td>
                  <v-text-field v-model="item.paramKey" :readonly="isView" variant="outlined" density="compact"
                    hide-details maxlength="128" class="gm-input" placeholder="请输入" />
                </td>
                <td>
                  <v-select v-model="item.dataType" :items="dataTypeItems" item-title="title" item-value="value"
                    :readonly="isView" :menu-props="{ disabled: isView }" variant="outlined" density="compact"
                    hide-details class="gm-input" placeholder="请选择" />
                </td>
                <td>
                  <v-text-field v-model="item.paramValue" :readonly="isView" variant="outlined" density="compact"
                    hide-details maxlength="512" class="gm-input" placeholder="请输入" />
                </td>
                <td v-if="!isView" class="text-center">
                  <v-btn variant="text" color="#FF6A46" size="small" @click="removeExtendParam(index)">删除</v-btn>
                </td>
              </tr>
              <tr v-if="!form.extendParams.length">
                <td :colspan="isView ? 5 : 6" class="text-center text-medium-emphasis py-4">暂无数据</td>
              </tr>
            </tbody>
          </table>

          <div class="section-title mt-6">备注信息</div>
          <v-textarea v-model="form.remark" :readonly="isView" variant="outlined" density="compact" hide-details
            rows="3" auto-grow maxlength="500" :counter="!isView" class="gm-input" placeholder="请输入备注信息" />
        </v-card-text>
        <v-card-actions class="px-8 pb-6 pt-0 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-8 mr-3" @click="editOpen = false">
            {{ isView ? '关闭' : '取消' }}
          </v-btn>
          <v-btn v-if="!isView" color="#2655f1" variant="flat" class="gm-btn-primary text-white px-8"
            @click="saveDialog">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteOpen" max-width="420" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-5">
          <div class="text-h5"><span style="color: #3a68ff">删除</span><span>确认</span></div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="deleteOpen = false" />
        </div>
        <v-card-text class="pa-8 pt-2">确认删除「{{ deleteTarget?.modelName }}」？</v-card-text>
        <v-card-actions class="px-8 pb-6 pt-4 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-8 mr-3"
            @click="deleteOpen = false">取消</v-btn>
          <v-btn color="#3a68ff" variant="flat" class="gm-btn-primary text-white px-8" @click="confirmDelete">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { eui } from 'ems-ui'
import TablePagination from '@/components/TablePagination/index.vue'
import {
  addPhotovoltaicModel,
  deletePhotovoltaicModel,
  getPhotovoltaicModel,
  listPhotovoltaicModel,
  updatePhotovoltaicModel,
} from '@/api/device/model'

const dataTypeItems = [
  { title: '字符串', value: 1 },
  { title: '整数', value: 2 },
  { title: '小数', value: 3 },
  { title: '布尔', value: 4 },
]

function createExtendParam() {
  return { paramName: '', paramKey: '', paramValue: '', dataType: 1, unit: '' }
}

const listLoading = ref(false)
const rows = ref([])
const total = ref(0)
const page = ref(1)
const pageSize = ref(10)
const queryForm = reactive({
  modelName: '',
  factoryName: '',
  productModel: '',
})

const editOpen = ref(false)
const deleteOpen = ref(false)
const dialogMode = ref('edit')
const deleteTarget = ref(null)
const editingId = ref(null)
const showValidation = ref(false)

const isView = computed(() => dialogMode.value === 'view')
const dialogTitle = computed(() => {
  if (dialogMode.value === 'add') return '新增'
  if (dialogMode.value === 'view') return '查看'
  return '编辑'
})

const form = reactive({
  modelName: '',
  factoryName: '',
  productModel: '',
  maxDcVoltage: '',
  maxDcPower: '',
  ratedOutputPower: '',
  maxOutputPower: '',
  maxAcOutputCurrent: '',
  maxInputCurrent: '',
  ratedGridVoltage: '',
  ratedGridFrequency: '',
  remark: '',
  extendParams: [],
})

function addExtendParam() {
  form.extendParams.push(createExtendParam())
}

function removeExtendParam(index) {
  form.extendParams.splice(index, 1)
}

function firstValue(source, keys, defaultValue = '') {
  for (const key of keys) {
    if (source?.[key] !== undefined && source?.[key] !== null) return source[key]
  }
  return defaultValue
}

function normalizeRow(row) {
  return {
    ...row,
    id: firstValue(row, ['id', 'modelId', 'photovoltaicModelId', 'pvModelId']),
    modelName: firstValue(row, ['modelName']),
    factoryName: firstValue(row, ['factoryName']),
    productModel: firstValue(row, ['productModel']),
    maxDcVoltage: firstValue(row, ['maxDcVoltage']),
    maxDcPower: firstValue(row, ['maxDcPower']),
    ratedOutputPower: firstValue(row, ['ratedOutputPower']),
    maxOutputPower: firstValue(row, ['maxOutputPower']),
    maxAcOutputCurrent: firstValue(row, ['maxAcOutputCurrent']),
    maxInputCurrent: firstValue(row, ['maxInputCurrent']),
    ratedGridVoltage: firstValue(row, ['ratedGridVoltage']),
    ratedGridFrequency: firstValue(row, ['ratedGridFrequency']),
    remark: firstValue(row, ['remark']),
    extendParams: Array.isArray(row?.extendParams) ? row.extendParams : [],
  }
}

function getListFromResponse(res) {
  const data = res?.data ?? res
  if (Array.isArray(res?.rows)) return res.rows
  if (Array.isArray(data?.rows)) return data.rows
  if (Array.isArray(data?.records)) return data.records
  if (Array.isArray(data?.list)) return data.list
  if (Array.isArray(data)) return data
  return []
}

function getTotalFromResponse(res, list) {
  const data = res?.data ?? res
  const totalValue = res?.total ?? data?.total ?? data?.count
  return Number.isFinite(Number(totalValue)) ? Number(totalValue) : list.length
}

function buildQueryParams() {
  const params = {
    pageNum: page.value,
    pageSize: pageSize.value,
  }

  const modelName = queryForm.modelName.trim()
  const factoryName = queryForm.factoryName.trim()
  const productModel = queryForm.productModel.trim()

  if (modelName) params.modelName = modelName
  if (factoryName) params.factoryName = factoryName
  if (productModel) params.productModel = productModel

  return params
}

function buildPayload() {
  const extendParams = form.extendParams
    .filter(item => (item.paramName || '').trim() && (item.paramKey || '').trim())
    .map(item => ({
      paramName: item.paramName.trim(),
      unit: item.unit ?? '',
      paramKey: item.paramKey.trim(),
      dataType: Number(item.dataType) || 1,
      paramValue: item.paramValue ?? '',
    }))
  return {
    modelName: form.modelName.trim(),
    factoryName: form.factoryName.trim(),
    productModel: form.productModel.trim(),
    maxDcVoltage: String(form.maxDcVoltage || ''),
    maxDcPower: String(form.maxDcPower || ''),
    ratedOutputPower: String(form.ratedOutputPower || ''),
    maxOutputPower: String(form.maxOutputPower || ''),
    maxAcOutputCurrent: String(form.maxAcOutputCurrent || ''),
    maxInputCurrent: String(form.maxInputCurrent || ''),
    ratedGridVoltage: String(form.ratedGridVoltage || ''),
    ratedGridFrequency: String(form.ratedGridFrequency || ''),
    remark: form.remark || '',
    extendParams,
  }
}

const modelNameErrors = computed(() => {
  if (isView.value || !showValidation.value || form.modelName.trim()) return []
  return ['请输入型号名称']
})

const productModelErrors = computed(() => {
  if (isView.value || !showValidation.value || form.productModel.trim()) return []
  return ['请输入产品型号']
})

function validateForm() {
  showValidation.value = true
  if (!form.modelName.trim()) {
    eui.showToast('请输入型号名称', 'error')
    return false
  }
  if (!form.productModel.trim()) {
    eui.showToast('请输入产品型号', 'error')
    return false
  }
  return true
}

function handleQuery() {
  page.value = 1
  fetchRows()
}

function handleReset() {
  queryForm.modelName = ''
  queryForm.factoryName = ''
  queryForm.productModel = ''
  page.value = 1
  pageSize.value = 10
  fetchRows()
}

async function fetchRows() {
  listLoading.value = true
  try {
    const res = await listPhotovoltaicModel(buildQueryParams())
    const list = getListFromResponse(res)
    rows.value = Array.isArray(list) ? list.map(normalizeRow) : []
    total.value = getTotalFromResponse(res, rows.value)
  } finally {
    listLoading.value = false
  }
}

function resetFormFromRow(row) {
  form.modelName = row.modelName || ''
  form.factoryName = row.factoryName || ''
  form.productModel = row.productModel || ''
  form.maxDcVoltage = String(row.maxDcVoltage ?? '')
  form.maxDcPower = String(row.maxDcPower ?? '')
  form.ratedOutputPower = String(row.ratedOutputPower ?? '')
  form.maxOutputPower = String(row.maxOutputPower ?? '')
  form.maxAcOutputCurrent = String(row.maxAcOutputCurrent ?? '')
  form.maxInputCurrent = String(row.maxInputCurrent ?? '')
  form.ratedGridVoltage = String(row.ratedGridVoltage ?? '')
  form.ratedGridFrequency = String(row.ratedGridFrequency ?? '')
  form.remark = row.remark || ''
  form.extendParams = (row.extendParams || []).map(item => ({
    paramName: item.paramName || '',
    paramKey: item.paramKey || '',
    paramValue: item.paramValue ?? '',
    dataType: item.dataType ? Number(item.dataType) : 1,
    unit: item.unit || '',
  }))
}

async function openEdit(row) {
  dialogMode.value = 'edit'
  editingId.value = row.id
  showValidation.value = false
  resetFormFromRow(row)
  editOpen.value = true
  const res = await getPhotovoltaicModel(row.id)
  const detail = res?.data ?? res
  if (detail && typeof detail === 'object') {
    resetFormFromRow(normalizeRow(detail))
  }
}

async function openView(row) {
  dialogMode.value = 'view'
  editingId.value = row.id
  showValidation.value = false
  resetFormFromRow(row)
  editOpen.value = true
  const res = await getPhotovoltaicModel(row.id)
  const detail = res?.data ?? res
  if (detail && typeof detail === 'object') {
    resetFormFromRow(normalizeRow(detail))
  }
}

function openAdd() {
  dialogMode.value = 'add'
  editingId.value = null
  showValidation.value = false
  form.modelName = ''
  form.factoryName = ''
  form.productModel = ''
  form.maxDcVoltage = ''
  form.maxDcPower = ''
  form.ratedOutputPower = ''
  form.maxOutputPower = ''
  form.maxAcOutputCurrent = ''
  form.maxInputCurrent = ''
  form.ratedGridVoltage = ''
  form.ratedGridFrequency = ''
  form.remark = ''
  form.extendParams = []
  editOpen.value = true
}

async function saveDialog() {
  if (!validateForm()) return

  const payload = buildPayload()
  if (dialogMode.value === 'add') {
    await addPhotovoltaicModel(payload)
    eui.showToast('新增成功', 'success')
  } else {
    await updatePhotovoltaicModel({ ...payload, id: editingId.value })
    eui.showToast('编辑成功', 'success')
  }
  showValidation.value = false
  editOpen.value = false
  await fetchRows()
}

function openDelete(row) {
  deleteTarget.value = row
  deleteOpen.value = true
}

async function confirmDelete() {
  if (!deleteTarget.value) return
  await deletePhotovoltaicModel(deleteTarget.value.id)
  eui.showToast('删除成功', 'success')
  deleteOpen.value = false
  deleteTarget.value = null
  const shouldGoPrevPage = rows.value.length === 1 && page.value > 1
  if (shouldGoPrevPage) {
    page.value -= 1
  }
  await fetchRows()
}

onMounted(fetchRows)
</script>

<style scoped lang="scss">
@import '../_dialog-styles.scss';

.pm-pv {
  min-height: 360px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .search-label {
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }

  .search-input {
    width: 220px;
  }
}

.pv-table-outer {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}

.table-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  min-width: 1200px;
  overflow: hidden;
}

.pm-table-native.v-table {
  width: 100%;
  min-width: 1200px;
  flex: 1 1 0;
  min-height: 0;
  height: 0;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

.pm-prop-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th,
  td {
    border: 1px solid var(--color-td-border, #e9efff);
    padding: 8px 10px;
    vertical-align: middle;
  }

  thead th {
    background: rgba(38, 85, 241, 0.06);
    font-weight: 500;
  }

  .col-name {
    width: 22%;
  }

  .col-unit {
    width: 12%;
  }

  .col-ext-name {
    width: 22%;
  }

  .col-ext-unit {
    width: 14%;
  }

  .col-ext-key {
    width: 18%;
  }

  .col-ext-type {
    width: 16%;
  }

  .col-ext-val {
    width: 22%;
  }

  .col-ext-op {
    width: 12%;
  }
}

.required-star {
  color: #ff4d4f;
}
</style>
